import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IPermission, IAllPermsByRol } from '../../interfaces/DB/i-permission';
import { IPermssionsByRol, IRol, IRolResponse } from '../../interfaces/DB/i-rols';
import { IResponse } from '../../interfaces/Responses/i-responses';

@Injectable({
  providedIn: 'root'
})
export class RolService {

  constructor(
    private http: HttpClient,
  ) { }

  GetRols(): Observable<IResponse<IRol[]>> {
    return this.http.get<IResponse<IRol[]>>(`${environment.ApiUrl}api/Rol/GetRols`);
  }

  StoreRol(rol : IRol): Observable<IResponse<boolean>> {   
    return this.http.post<IResponse<boolean>>(`${environment.ApiUrl}api/Rol/StoreRol`, rol);
  }
  
  StorePermissionsByRol(permsByRol : IPermssionsByRol): Observable<IResponse<boolean>> {  
    return this.http.post<IResponse<boolean>>(`${environment.ApiUrl}api/Rol/StorePermissionsByRol`, permsByRol);
  }

  GetAllPermissionsByRol(id : number): Observable<IResponse<IAllPermsByRol>> {
    return this.http.get<IResponse<IAllPermsByRol>>(`${environment.ApiUrl}api/Rol/GetAllPermissionsByRol/${id}`);
  }

  GetPermissionsByRolId(id: number): Observable<IResponse<IPermission[]>>{
    return this.http.get<IResponse<IPermission[]>>(`${environment.ApiUrl}api/Rol/GetPermissionsByRol/${id}`);
  }
  

}
